import { render, staticRenderFns } from "./ShareMenuItem.vue?vue&type=template&id=b3c8ae50&scoped=true&"
import script from "./ShareMenuItem.vue?vue&type=script&lang=js&"
export * from "./ShareMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c8ae50",
  null
  
)

export default component.exports